"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modals = void 0;
var Modals;
(function (Modals) {
    Modals[Modals["LocationModal"] = 0] = "LocationModal";
    Modals[Modals["LocationSelectModal"] = 1] = "LocationSelectModal";
    Modals[Modals["LoginModal"] = 2] = "LoginModal";
    Modals[Modals["ConfirmModal"] = 3] = "ConfirmModal";
    Modals[Modals["FilesModal"] = 4] = "FilesModal";
    Modals[Modals["ImageModal"] = 5] = "ImageModal";
    Modals[Modals["InfoModal"] = 6] = "InfoModal";
    Modals[Modals["CardModal"] = 7] = "CardModal";
    Modals[Modals["OrdersModal"] = 8] = "OrdersModal";
    Modals[Modals["ResetPasswordModal"] = 9] = "ResetPasswordModal";
    Modals[Modals["FeedbackModal"] = 10] = "FeedbackModal";
    Modals[Modals["RestoreModal"] = 11] = "RestoreModal";
    Modals[Modals["WarehouseModal"] = 12] = "WarehouseModal";
    Modals[Modals["UploadModal"] = 13] = "UploadModal";
    Modals[Modals["RatingModal"] = 14] = "RatingModal";
    Modals[Modals["CostAdjustmentModal"] = 15] = "CostAdjustmentModal";
    Modals[Modals["ConfirmOrderModal"] = 16] = "ConfirmOrderModal";
    Modals[Modals["TermsModal"] = 17] = "TermsModal";
    Modals[Modals["ChangePasswordModal"] = 18] = "ChangePasswordModal";
    Modals[Modals["ConfirmDistributionOrderModal"] = 19] = "ConfirmDistributionOrderModal";
    Modals[Modals["RegisterModal"] = 20] = "RegisterModal";
    Modals[Modals["NewWarehouseModal"] = 21] = "NewWarehouseModal";
    Modals[Modals["NewCarrierModal"] = 22] = "NewCarrierModal";
    Modals[Modals["ManagerModal"] = 23] = "ManagerModal";
    Modals[Modals["UpdatePermissionsModal"] = 24] = "UpdatePermissionsModal";
    Modals[Modals["EntityManagerModal"] = 25] = "EntityManagerModal";
    Modals[Modals["DispatchDriverModal"] = 26] = "DispatchDriverModal";
    Modals[Modals["OneFieldModal"] = 27] = "OneFieldModal";
    Modals[Modals["OptionsModal"] = 28] = "OptionsModal";
    Modals[Modals["RejectCostAdjustmentModal"] = 29] = "RejectCostAdjustmentModal";
    Modals[Modals["ModalsBookNoRegisterModal"] = 30] = "ModalsBookNoRegisterModal";
    Modals[Modals["AdminEditorModal"] = 31] = "AdminEditorModal";
    Modals[Modals["ConfirmPricesModal"] = 32] = "ConfirmPricesModal";
    Modals[Modals["RequestSolutionModal"] = 33] = "RequestSolutionModal";
    Modals[Modals["ReassignOrderModal"] = 34] = "ReassignOrderModal";
    Modals[Modals["DeleteAccountModal"] = 35] = "DeleteAccountModal";
    Modals[Modals["UnableDeleteAccountModal"] = 36] = "UnableDeleteAccountModal";
    Modals[Modals["LoadBoardPostFormModal"] = 37] = "LoadBoardPostFormModal";
    Modals[Modals["LoadBoardPostDetailModal"] = 38] = "LoadBoardPostDetailModal";
    Modals[Modals["SignInModal"] = 39] = "SignInModal";
    Modals[Modals["CalculateSpaceModal"] = 40] = "CalculateSpaceModal";
    Modals[Modals["AddWarehouseModal"] = 41] = "AddWarehouseModal";
    Modals[Modals["PrimaryContactModal"] = 42] = "PrimaryContactModal";
    Modals[Modals["DeleteTableRecordModal"] = 43] = "DeleteTableRecordModal";
    Modals[Modals["AddStaffModal"] = 44] = "AddStaffModal";
    Modals[Modals["DeleteStaffModal"] = 45] = "DeleteStaffModal";
    Modals[Modals["ManageStaffModal"] = 46] = "ManageStaffModal";
    Modals[Modals["InsuranceUploadModal"] = 47] = "InsuranceUploadModal";
    Modals[Modals["InvoiceUploadModal"] = 48] = "InvoiceUploadModal";
    Modals[Modals["InsuranceRequirementsModal"] = 49] = "InsuranceRequirementsModal";
})(Modals = exports.Modals || (exports.Modals = {}));
